export default __webpack_public_path__ + "static/hero_bg_optimized-811374c3f3cfb8039d852faf8f5e9f56.jpg";